import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateRegistroContableRequest extends CreateKeyValueRequest {

  importe!: number;
  fecha!: Date;
  aprobadoPor!: number;
  cotizacionMonedaOrigen!: number;
  importeMonedaOrigen!: number;
  idCuentaContable!: number;
  idAsientoContable!: number;
  idArchivo!: number;
  referenciaExterna!: string;
  etiqueta!: string;
  idRegistroRelacionado!: number;
  origen!: string;
  idComprobante!: number;
  esEditable!: boolean;
  fechaAprobacion!: Date;
  idEstadoRegistroContable!: number;
  idTipoRegistroContable!: number;
  idPlanillaCaja!: number;
  idCuentaCaja!: number;
  idTipoMonedaLocal!: number;
  idTipoMonedaOrigen!: number;
  idExpediente!: number;
}
